import React from 'react'
import DashboardStatsGrid from './DashboardStatsGrid';
import BoxWrapper from './BoxWrapper';
import BarChart from './test/BarChart';
import PieChart from './test/PieChart';

const UserDashboard = () => {
  return (
    <div className='w-full pb-6'>

      <div className='flex p-6 gap-6'>
        <div className='w-3/4'>
          <DashboardStatsGrid />
        </div>
        <div className=' w-2/4'>
          <BoxWrapper title={'Bar Chart'}>
            <div className='flex-1 '>
              <div className=' w-full h-64 mt-4'>
                <BarChart />
              </div>
            </div>
          </BoxWrapper>
        </div>
        
      </div>

      <div className="flex gap-6 px-6">
        <div className="w-2/4 ">
          <BoxWrapper title={'Pie Chart'}>
            <div className='flex-1 '>
                <div className=' w-full h-56 mt-4'>
                  <PieChart />
                </div>
            </div>
          </BoxWrapper>
        </div>
        <div className="w-1/4 ">
          <BoxWrapper title={'Chart'}>
            <div className='flex-1 '>
                  <div className=' w-full h-56 mt-4'>
                    
                  </div>
            </div>
          </BoxWrapper>
        </div>
        <div className="w-1/4 ">
        <BoxWrapper title={'Chart'}>
            <div className='flex-1 '>
                  <div className=' w-full h-56 mt-4'>
                    
                  </div>
            </div>
          </BoxWrapper>
        </div>

      </div>

      <div className="flex gap-6 px-6 mt-6">
        <div className="w-2/4 ">
        <BoxWrapper title={'Chart'}>
            <div className='flex-1 '>
                <div className=' w-full h-56 mt-4'>
                  
                </div>
            </div>
          </BoxWrapper>
        </div>
        <div className="w-1/4 ">
        <BoxWrapper title={'Chart'}>
            <div className='flex-1 '>
                  <div className=' w-full h-56 mt-4'>
                    
                  </div>
            </div>
          </BoxWrapper>
        </div>
        <div className="w-1/4 ">
        <BoxWrapper title={'Chart'}>
            <div className='flex-1 '>
                  <div className=' w-full h-56 mt-4'>
                    
                  </div>
            </div>
          </BoxWrapper>
        </div>

      </div>

    </div>
  )
}

export default UserDashboard